import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AdminRoutes from 'page/admin/admin.routes';
import AdminHeader from 'components/admin/common/AdminNavbar';
import AdminSidebar from 'components/admin/common/sidebar/AdminSidebar';

const Admin = () => {
    const history = useHistory();

    useEffect(() => {
        const isAdmin = localStorage.getItem('isAdmin');
        if (isAdmin !== 'true') {
            history.push('/');
        }
    }, [history]);

    return (
        <div className="admin-container">
            <AdminSidebar />
            <div className="admin-content">
                <AdminHeader />
                <AdminRoutes />
            </div>
        </div>
    );
};

export default Admin;